import { z } from "zod";

export const RequestHelperGetContractPrepopInfoInputSchema = z.object({
    poistkaId: z.number(),
    isVehicle: z.boolean(),
    needClientEmail: z.boolean(),
    vehicleRowId: z.union([z.string(), z.number()]).nullish(),
});

export type RequestHelperGetContractPrepopInfoInput = z.infer<typeof RequestHelperGetContractPrepopInfoInputSchema>;